var render = function render(){var _vm=this,_c=_vm._self._c;return _c('preliminary-results-template',{attrs:{"personal-fields":_vm.personalFields,"photo-diagnostic-results":_vm.photoAnalysisDiagnostic,"patient-photo":_vm.patientPhoto,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }